import { render, staticRenderFns } from "./notariza.vue?vue&type=template&id=2b8a1271"
import script from "./notariza.vue?vue&type=script&lang=js"
export * from "./notariza.vue?vue&type=script&lang=js"
import style0 from "./notariza.vue?vue&type=style&index=0&id=2b8a1271&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports